module.exports = __webpack_public_path__ + "img/logoweissHA2.a2a5e4ab.png";